<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="!selectedContract">
          Selezionare un veicolo
        </b-card>
        <b-card v-else>
          <div slot="header">
            Richieste del veicolo: <strong>{{ selectedContract.alias }}</strong>
            <div v-if="selectedContract" class="card-header-actions">
              <b-link @click="loadRequests" href="#" class="card-header-action">
                <i class="icon-refresh"></i>
              </b-link>
            </div>
          </div>
          <div v-if="loading" class="sk-wave">
            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
          </div>

          <b-table v-else hover striped bordered small stacked="sm" responsive :items="requests" :fields="fields">
            <template slot="origin" slot-scope="data">
              {{ getOriginText(data.item.origin) }}
            </template>
            <template slot="command" slot-scope="data">
              {{ getCommandText(data.item.command) }}
            </template>
            <template slot="parameters" slot-scope="data">
              <b-badge :variant="getParametersBadge(data.item.parameters)">{{ getParametersText(data.item.parameters) }}</b-badge>
            </template>
            <template slot="status" slot-scope="data">
              <b-badge :variant="getStatusBadge(data.item.status)">{{ getStatusText(data.item.status)}}</b-badge>
            </template>
            <template slot="createdAt" slot-scope="data">
              {{ data.item.createdAt | formatDate  }}
            </template>
            <template slot="executedAt" slot-scope="data">
              {{ data.item.executedAt | formatDate }}
            </template>
          </b-table>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  UPDATE_REQUEST
} from "@/store/mutation-types";

export default {
  name: 'requests',
  data () {
    return {
      loading: false,
      fields: [{
          key: 'subuser',
          label: 'Utente'
        },{
          key: 'origin',
          label: 'Origine'
        }, {
          key: 'command',
          label: 'Comando',
          sortable: true
        }, {
          key: 'parameters',
          label: 'Parametri',
          sortable: false
        }, {
          key: 'status',
          label: 'Stato',
          sortable: true,
        }, {
          key: 'createdAt',
          label: 'Data creazione',
          sortable: true,
        }, {
          key: 'executedAt',
          label: 'Data esecuzione',
          sortable: true,
        }
      ]}
  },
  methods: {
    loadRequests() {
      this.loading = true;
      this.$store.dispatch('requests', { contractId: this.$store.getters.selectedContract.id })
        .then((requests) => console.log('requests loaded'))
        .catch(err => console.log(err))
        .finally(() => this.loading = false);
    },
    getStatusBadge (status) {
      switch(status) {
        case 0:
        case 1:
          return 'warning';
        case 3:
          return 'success';
        case 7:
          return 'info';
        case 8:
          return 'primary';
        case 4:
          return 'danger';
      }
    },
    getStatusText (status) {
      switch(status) {
        case 0:
        case 1:
          return 'IN CORSO';
        case 3:
          return 'ESEGUITA';
        case 7:
          return 'DUPLICATA';
        case 8:
          return 'TIMEOUT';
        case 4:
          return 'ERRORE';
      }
    },
    getOriginText (origin) {
      switch(origin) {
        case 1:
          return 'Portale Web';
        case 6:
          return 'API';
        case 11:
          return 'iOS/Android App'
        default:
          return '???'
      }
    },
    getCommandText (command) {
      switch(command) {
        case 'LOCATE':
          return 'Localizzazione'
        case 'ALARM':
        case 'ALARM_SEMS':
          return 'Allarme';
        case 'ENGINE_IMMOBILIZER':
          return 'Blocco motore';
        case 'TRACKING':
          return 'Tracking';
        default:
          return '???'
      }
    },
    getParametersText (parameters) {
      if (!parameters) { return ''; }

      return parameters === '1' ? 'ON' : 'OFF'
    },
    getParametersBadge (parameters) {
      if (!parameters) { return ''; }

      return parameters === '1' ? 'success' : 'danger'
    }
  },
  mounted() {
    if (this.$store.getters.selectedContract) {
      this.loadRequests();
    }
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === UPDATE_REQUEST) {
        this.loadRequests();
      }
    })
  },
  computed: {
    ...mapGetters([
        'requests',
        'selectedContract'
      ]),
  },
  watch: {
    selectedContract(newSelectedContract, oldSelectedContract) {
      if (!oldSelectedContract || newSelectedContract.id != oldSelectedContract.id) {
        this.loadRequests();
      }
    },
    requests(newRequests, oldRequests) {
      console.log('newRequests');
    }
  }
}
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
